import type { BaseAppConfig } from "./appConfig";

/**
 * Temporary: the config of a project that has not migrated to runtime config.
 * Reproduces exactly what src/common read from process.env before the switch.
 * Delete once every consumer of react-common calls initAppConfig({ requireRuntime: true }).
 *
 * The returned object is deliberately NOT frozen, and values deliberately pass
 * through untouched (including `undefined`), exactly as the old direct
 * process.env reads did. Do not "tidy" it: legacy behaviour must stay
 * byte-identical until both apps migrate and this file is deleted.
 */
const buildLegacyEnvConfig = (): BaseAppConfig =>
  ({
    appName: process.env.REACT_APP_NAME + "",
    storageNamespace: process.env.REACT_APP_NAME + "",
    storageEncryptionKey:
      process.env.REACT_APP_SECURE_LOCAL_STORAGE_HASH_KEY ||
      "qrqwgt@1131451HHFHJhkjH^^&*&$###",
    apiBaseUrl:
      (process.env.REACT_APP_HTTPS === "true" ? "https://" : "http://") +
      process.env.REACT_APP_API_URL +
      process.env.REACT_APP_VERSION,
    visaHeaderName: process.env.REACT_APP_VISA_PREFIX,
    visaHeaderValue: process.env.REACT_APP_ETPA_VISA,
    viewAsEnabled: process.env.REACT_APP_VIEW_AS_ENABLED === "true",
    viewAsKey: process.env.REACT_APP_VIEW_AS_KEY,
    viewAsUserProperty: process.env.REACT_APP_VIEW_AS_USER_PROPERTY,
    routerBasename: process.env.REACT_APP_ROUTER_BASENAME,
    publicUrl: process.env.PUBLIC_URL,
    templatesPath: process.env.REACT_APP_TEMPLATES_PATH,
    tinymceApiKey: process.env.REACT_APP_TINYMCE_API_KEY,
    primaryColor: process.env.REACT_APP_PRIMARY_COLOR,
    secondaryColor: process.env.REACT_APP_SECONDARY_COLOR,
    companyNameEn: process.env.REACT_APP_COMPANY_NAME_EN,
    companyNameAr: process.env.REACT_APP_COMPANY_NAME_AR,
    companyLogoUrl: process.env.REACT_APP_COMPANY_LOGO,
    companyLogoMenuUrl: process.env.REACT_APP_COMPANY_LOGO_MENU,
    companyLogoMiniUrl: process.env.REACT_APP_COMPANY_LOGO_MINI,
    companyLogoPadding: process.env.REACT_APP_COMPANY_LOGO_PADDING,
  }) as unknown as BaseAppConfig;

export default buildLegacyEnvConfig;
